import { TweenLite } from 'gsap/TweenLite';
import _debounce from 'lodash/debounce';

export default class AnimatedListLine {
  constructor(list) {
    this.list = list;
    this.hover = this.list.dataset.hoverLine;
    this.listItems = Array.from(this.list.querySelectorAll('[data-role*="list-item"]'));
    this.line = this.list.querySelector('[data-role="forward-line"]');
    this.duration = document.documentElement.dataset.duration;
    this.init();
  }

  setStyle(target) {
    const {
      offsetLeft, offsetWidth, offsetHeight, offsetTop,
    } = target;
    TweenLite.to(this.line, this.duration, { x: offsetLeft, width: offsetWidth, y: offsetHeight + offsetTop });
  }

  forwardHovered(e) {
    const { target } = e;
    return this.setStyle(target);
  }

  backToActive() {
    const target = this.list.querySelector('.is-active');
    if (!target) return false;
    return this.setStyle(target);
  }

  init() {
    if (this.hover) {
      this.listItems.forEach((item) => {
        item.addEventListener('mouseenter', this.forwardHovered.bind(this));
        item.addEventListener('mouseleave', this.backToActive.bind(this));
      });
    }

    this.backToActive();
    this.list.addEventListener('updateLine', () => {
      this.backToActive();
    });

    window.addEventListener('resize', _debounce(() => this.backToActive(), 50));
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/AnimatedListLine/AnimatedListLine.js